import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestCreateCookiePolicyPost = {
    path: "/create-cookie-policy",
    method: RouteHttpVerb.POST
};
export { locationRestCreateCookiePolicyPost };
